import React from 'react'

const MainContainer = ({children}) => {
  return <main id="ts-content">
    {children}
  </main>
}

export default MainContainer
